import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CeAlert } from 'api/status.api';
import { TimeDisplayService } from 'shared/time-display-service/time-display.service';
import { SeverityIcon } from 'shared/alert-problem-service/alert-problem.service';

@Component({
    selector: 'ce-alert-badge',
    templateUrl: './alert-badge.component.html',
    styleUrls: ['./alert-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertBadgeComponent {
    @Input() headerStyle = false;
    @Input() alert: CeAlert;
    @Input() displayStation = false;
    @Input() severityIcon?: SeverityIcon; // Optional dynamic severity icon

    currentTime$ = this.timeDisplayService.timeObservable$;

    constructor(private timeDisplayService: TimeDisplayService) {}

    get iconToUse(): { svgIcon: string; class: string } {
        return this.severityIcon || { svgIcon: 'exclamation-thick', class: '' };
    }
}
